export default __webpack_public_path__ + "static/door_w.cc3867a7501e20409a4a6a14cb7ee468.png";